/*
 * sr-mobile-menu.js
 * -----------------
 * Lógica de tabs SHOP/ABOUT + submenús del menú mobile Serené.
 * - Cero dependencias. Defer.
 * - Scoped a .sr-mm dentro de <header-drawer>.
 * - Cierra drawer al hacer click en el botón close [data-sr-mm-close].
 * - El abrir/cerrar del drawer (hamburger ↔ <details>) lo maneja el theme.
 */
(function () {
  'use strict';

  function setTab(root, tabName) {
    var tabs = root.querySelectorAll('[data-sr-mm-tab]');
    var panels = root.querySelectorAll('[data-sr-mm-panel]');
    tabs.forEach(function (t) {
      var isActive = t.getAttribute('data-sr-mm-tab') === tabName;
      t.classList.toggle('is-active', isActive);
      t.setAttribute('aria-selected', isActive ? 'true' : 'false');
    });
    panels.forEach(function (p) {
      var match = p.getAttribute('data-sr-mm-panel') === tabName;
      if (match) p.removeAttribute('hidden');
      else p.setAttribute('hidden', '');
    });
  }

  function openSub(root, subName) {
    var sub = root.querySelector('[data-sr-mm-sub="' + subName + '"]');
    if (!sub) return;
    sub.removeAttribute('hidden');
    // Force reflow then add is-open for transition
    requestAnimationFrame(function () {
      sub.classList.add('is-open');
    });
    root.setAttribute('data-sub-open', subName);
  }

  function closeSub(root) {
    var open = root.querySelectorAll('.sr-mm__sub.is-open');
    open.forEach(function (sub) {
      sub.classList.remove('is-open');
      setTimeout(function () {
        if (!sub.classList.contains('is-open')) sub.setAttribute('hidden', '');
      }, 260);
    });
    root.removeAttribute('data-sub-open');
  }

  function closeDrawer() {
    // Theme drawer uses <details id="Details-menu-drawer-container">
    var details = document.getElementById('Details-menu-drawer-container');
    if (details && details.open) {
      // Simulate click on summary (preferred by theme JS)
      var summary = details.querySelector('summary');
      if (summary) summary.click();
      else details.open = false;
    }
  }

  function bindRoot(root) {
    if (root.dataset.srMmBound === '1') return;
    root.dataset.srMmBound = '1';

    // Tabs + submenus + back + close
    // Importante: stopPropagation() en submenu/tab/back para evitar que
    // el theme handler global cierre el drawer al click en buttons internos.
    root.addEventListener('click', function (e) {
      var tab = e.target.closest('[data-sr-mm-tab]');
      if (tab && root.contains(tab)) {
        e.preventDefault();
        e.stopPropagation();
        setTab(root, tab.getAttribute('data-sr-mm-tab'));
        closeSub(root);
        return;
      }
      var submenu = e.target.closest('[data-sr-mm-open]');
      if (submenu && root.contains(submenu)) {
        e.preventDefault();
        e.stopPropagation();
        openSub(root, submenu.getAttribute('data-sr-mm-open'));
        return;
      }
      var back = e.target.closest('[data-sr-mm-back]');
      if (back && root.contains(back)) {
        e.preventDefault();
        e.stopPropagation();
        closeSub(root);
        return;
      }
      var close = e.target.closest('[data-sr-mm-close]');
      if (close && root.contains(close)) {
        e.preventDefault();
        e.stopPropagation();
        closeSub(root);
        closeDrawer();
        return;
      }
    }, true);  // capture phase → corremos ANTES que cualquier theme handler

    // Defensa extra: previene cierre por handler genérico del theme
    // sobre click en cualquier <button type="button"> dentro del drawer
    // que NO sea un link final (anchor).
    root.addEventListener('click', function (e) {
      var btn = e.target.closest('button[data-sr-mm-open], button[data-sr-mm-back], button[data-sr-mm-tab]');
      if (btn && root.contains(btn)) {
        e.stopPropagation();
      }
    });
  }

  function init() {
    document.querySelectorAll('.sr-mm').forEach(bindRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (e) {
    if (!e.target) return;
    e.target.querySelectorAll('.sr-mm').forEach(bindRoot);
  });

  // Cuando el drawer del theme se cierra, reset submenús
  document.addEventListener('click', function (e) {
    if (e.target.closest('summary[aria-label="Menu"], summary[aria-label="menu"]')) {
      var root = document.querySelector('.sr-mm');
      if (root) {
        // Si el details acaba de abrir, mantener panel SHOP active
        setTimeout(function () {
          if (root) closeSub(root);
        }, 50);
      }
    }
  });
})();
